<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="item-note">
    <span v-html="text" />
  </div>
</template>

<script>
/**
 * Display a note of an Item
 *  @example [none]
 */
export default {
  name: 'ItemNote',
  props: {
    /**
     * Text to write inside the note
     */
    text: {
      type: String,
    },
  },
}
</script>

<style lang="stylus" scoped>
.item-note
  span
    m-font-size(16, 24)
    color: $grey-dark
</style>
